function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from 'styled-components';
import { useMemo } from 'react';
import { themeConfig } from "../../../theme";
import { getBreakpoints } from "../../../theme/selectors";
import { mediaQueryFunctionsListWithLimits } from "../../../theme/helpers";
export var useMediaQuery = function useMediaQuery(theme) {
  return useMemo(function () {
    return mediaQueryFunctionsListWithLimits(getBreakpoints(theme));
  }, [theme]);
};
export var addRowPropStyle = function addRowPropStyle(propName, style) {
  return function (props) {
    var mediaQuery = props.mediaQuery;
    var prop = props[propName];

    if (Array.isArray(prop)) {
      return prop.filter(function (breakpoint) {
        return themeConfig.breakpointNames.indexOf(breakpoint) > -1;
      }).map(function (breakpoint) {
        return mediaQuery[breakpoint](_templateObject(), style);
      });
    }

    if (themeConfig.breakpointNames.indexOf(prop) > -1) {
      return mediaQuery[prop](_templateObject2(), style);
    }

    if (prop) {
      return "\n      ".concat(style, "\n    ");
    }
  };
};
var addCenterStyle = addRowPropStyle('center', 'justify-content: center;');
var addLastStyle = addRowPropStyle('last', 'order: 1;');
var addFirstStyle = addRowPropStyle('first', 'order: -1;');
var addBetweenStyle = addRowPropStyle('between', 'justify-content: space-between;');
var addAroundStyle = addRowPropStyle('around', 'justify-content: space-around;');
var addBottomStyle = addRowPropStyle('bottom', 'align-items: flex-end;');
var addMiddleStyle = addRowPropStyle('middle', 'align-items: center;');
var addTopStyle = addRowPropStyle('top', 'align-items: start;');
var addEndStyle = addRowPropStyle('end', 'justify-content: flex-end;');
var addStartStyle = addRowPropStyle('start', 'justify-content: flex-start;');
var addFluidStyle = addRowPropStyle('fluid', 'width: 100%;');

var addReverseStyle = function addReverseStyle(_ref) {
  var column = _ref.column;

  if (column) {
    return addRowPropStyle('reverse', 'flex-direction: column-reverse;');
  }

  return addRowPropStyle('reverse', 'flex-direction: row-reverse;');
};

var addColumnStyle = addRowPropStyle('column', 'flex-direction: column;');
var addGrowStyle = addRowPropStyle('grow', 'flex-grow: 1;');
var addShrinkStyle = addRowPropStyle('notShrink', 'flex-shrink: 0;');
export var addFlexStyles = function addFlexStyles() {
  return css(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], addColumnStyle, addReverseStyle, addStartStyle, addCenterStyle, addEndStyle, addTopStyle, addMiddleStyle, addBottomStyle, addAroundStyle, addBetweenStyle, addFirstStyle, addLastStyle, addGrowStyle, addShrinkStyle, addFluidStyle);
};